import Vue from 'vue'
import Cookies from 'js-cookie'
import Enum from 'vue-enum'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import Element from 'element-ui'
import moment from 'moment'

import './styles/element-variables.scss'

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import { hasShareAuTh } from '@/utils/js-methods'

import './icons' // icon
import './permission' // permission control
// import permission from './directive/permission/index'
import './utils/error-log' // error log
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import TapSearch from '@/components/TapSearch'
import ButtonBar from '@/components/ButtonBar'
import directives from '@/utils/directives/index'
import enumInfo from '@/constants/index'
import getTemplateUrl from '@/constants/fileTemplateUrls'
import { configureErrorReporter, reportError, reportErrorFromVue } from '@/utils/errorReporter'
// import callout from 'callout/es/index'
// import 'callout/lib/index.css'
// Vue.use(callout) //  "callout": "^1.2.3"

// 注册收集信息弹窗
import { showCollectInForDialog, hideCollectInForDialog } from '@/components/CollectInForDialog/index.js'
import CollectionInfoLayout from '@/components/CollectInForDialog/Layout'
// 公共搜索组件注册
import SearchBar from '@/components/SearchBar/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import Copy from '@/components/Copy';
Vue.component('SearchBar', SearchBar);
Vue.component('Pagination', Pagination);
// 注册全局$bus事件总栈
Vue.prototype.$bus = new Vue();
Vue.prototype.$showCollectInForDialog = showCollectInForDialog;
Vue.prototype.$hideCollectInForDialog = hideCollectInForDialog;
Vue.prototype.$hasShareAuTh = hasShareAuTh; // 注册全局方法-校验是否有公共页面权限点
Vue.component('Copy', Copy); // 全局注册复制文本组件
Vue.component('CollectionInfoLayout', CollectionInfoLayout);
Vue.component('ButtonBar', ButtonBar);
// 注册收集信息弹窗 --end
Vue.use(Enum, { enumInfo })
Vue.use(TapSearch)
Vue.use(directives)
Vue.use(Viewer, {
  defaultOptions: {
    title: false,
    navbar: false
  }
})
Vue.prototype.$getEnumValue = Vue.prototype.$enum.getDescByValue()
import echarts from 'echarts'

Vue.prototype.$echarts = echarts
Vue.prototype.$reportErrors = reportErrorFromVue
Vue.prototype.$moment = moment
Vue.prototype.commonVariable = true // 全局变量
Vue.prototype.$getTemplateUrl = getTemplateUrl // 全局获取模板文件地址函数
Vue.filter('moment', function (value, formatString) {
  formatString = formatString || 'YYYY-MM-DD HH:mm:ss'
  return moment(value).format(formatString)
})
// 全局注册过滤器
import * as filters from './filters' // global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

import mixinSearch from './views/mixin/mixinSearch'

Vue.mixin(mixinSearch)

Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size
})
// Vue.use(MyPlugin)
// ARMS阿里云前端监听
const armsEnv = ['local', 'daily', 'pre', 'prod']
if (armsEnv.includes(process.env.VUE_APP_ARMS)) {
  const BrowserLogger = require('alife-logger')
  const __bl = BrowserLogger.singleton({
    pid: 'iubok4zmpo@854a53a7c68e4fb',
    appType: 'web',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    enableSPA: true,
    environment: process.env.VUE_APP_ARMS,
    ignore: {
      ignoreErrors: ['Request failed with status code 403', 'timeout of 20000ms exceeded', 'UCShellJava.sdkEventFire is not a function', 'ResizeObserver loop limit exceeded']
    },
  })
  Vue.prototype.__bl = __bl
}

// 配置错误上报
configureErrorReporter({ platform: 'ARMS' })

if (window?.__bl) {
  // vue错误收集
  Vue.config.errorHandler = function (error, vm, info) {
    reportError(error,error, { filename: vm.$options?.__file, desc: info })
  }
  // js错误收集
  window.onerror = function (message, source, lineno, colno, error) {
    reportError(message, error, { filename: source, desc: message, position: { lineno, colno } })
  };
}


Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
